import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'

import { fetchForecast } from '../api'
import { ForecastPowerResponse } from 'src/Types/responses/storages/serialnumber/forecast/power'
import { useMemo } from 'react'
import { transformPvForecastDataBasedOnResolution } from '../utils'
import { usePortalQuery } from 'src/Libs/api'

export interface PVForecastReturnType {
  pvForecastData: ForecastPowerResponse[]
  isLoading: boolean
}
/**
 * Fetches the forecast power data by date range and storage id, with the ability to specify the resolution of the data (60 or 15 minutes).
 */
export const usePVForecastData = (from: Date, to: Date, storageId = '', resolution: 60 | 15 = 60): PVForecastReturnType => {
  const authFetch = useAuthFetchWithResponse()
  const fromRange = from.valueOf()
  const toRange = to.valueOf()

  const { data, isLoading } = usePortalQuery({
    queryKey: ['core-forecast-data', storageId, fromRange, toRange],
    queryFn: () => fetchForecast(storageId, fromRange, toRange, authFetch),
    enabled: !!storageId,
  })

  const pvForecastData: ForecastPowerResponse[] = useMemo(() => {
    if (!data) return []
    return transformPvForecastDataBasedOnResolution(data, resolution)
  }, [data, resolution])

  return { pvForecastData, isLoading }
}
